import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { CalendarService } from '../../../services/calendar.service';

@Component({
  selector: 'app-component-switcher',
  templateUrl: './component-switcher.component.html',
  styleUrls: ['./component-switcher.component.scss']
})
export class ComponentSwitcherComponent implements OnInit {
  checked = 'weight';
  isReadonly: boolean = false;
  disabled :boolean = false;
  @Output() schedule = new EventEmitter<number>();
  constructor(public calendarSvc: CalendarService) { 
  }
  ngOnInit() {
    this.calendarSvc.IsFilterbYCamp.subscribe((bool)=>{
      if(bool){
        this.schedule.emit(1);
        this.checked = 'dimensions';  
        this.disabled = true;     
      }
      else{
        this.schedule.emit(0);
        this.checked = 'weight';
        this.disabled = false;    
      }
    });
  }

  onCheck(val: number) {
    debugger;
    if(!this.disabled)
      this.schedule.emit(val);
  }
}





